'use client';

import type { ForgetPasswordOTPRequest } from '@/types';

import React from 'react';

import { CodeForm, MobileForm, PasswordForm } from './_components';

import { Stack } from '@/components';

const SignIn: React.FC = () => {
  const [forgetPasswordData, setForgetPasswordData] =
    React.useState<ForgetPasswordOTPRequest>({
      mobile: '',
      country_code_prefix: '+98',
    });
  const [status, setStatus] = React.useState<'mobile' | 'code' | 'password'>(
    'mobile'
  );
  const [csrfToken, setCsrfToken] = React.useState<string>('');

  const inView = {
    mobile: (
      <MobileForm
        goNext={(data) => {
          setForgetPasswordData(data);
          setStatus('code');
        }}
      />
    ),
    code: (
      <CodeForm
        mobile={forgetPasswordData.mobile}
        country_code_prefix={forgetPasswordData.country_code_prefix}
        goNext={({ token }) => {
          setStatus('password');
          setCsrfToken(token);
        }}
      />
    ),
    password: (
      <PasswordForm mobile={forgetPasswordData.mobile} csrfToken={csrfToken} />
    ),
  };

  return (
    <Stack flex={1} w="full" h="100%" align="center">
      {inView[status]}
      <Stack mt="auto" w="100%" align="center" justify="center"></Stack>
    </Stack>
  );
};

export default SignIn;
